const e = /* @__PURE__ */ Symbol("elPaginationKey");
export {
  e as elPaginationKey
};
